import { Component } from 'react';

// Keep render/commit failures readable even when the failed subtree includes
// theme providers or the logo preview. No diagnostic is sent to a third party.
export default class AppErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[pos/ui-render]', {
      path: window.location.pathname,
      name: error?.name || 'Error',
      message: String(error?.message || error).slice(0, 500),
      componentStack: info.componentStack,
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    const error = this.state.error;
    const detail = `${error?.name || 'Error'}: ${String(error?.message || error).slice(0, 500)}`;
    return <main role="alert" data-testid="app-render-error" style={{
      position: 'fixed', inset: 0, zIndex: 2147483647, overflow: 'auto',
      background: '#ffffff', color: '#172033', padding: '32px 20px',
      fontFamily: 'Arial, sans-serif', lineHeight: 1.6,
    }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{ fontSize: 22, margin: '0 0 12px' }}>Tampilan POS mengalami kendala</h1>
        <p>Halaman berhenti ditampilkan. Catat tulisan di bawah ini agar penyebabnya dapat diperiksa.</p>
        <p><strong>Kode: UI-RENDER</strong></p>
        <pre data-testid="app-render-error-detail" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', background: '#f1f5f9', padding: 12, fontSize: 14 }}>{detail}</pre>
        <p>Muat ulang untuk kembali ke pengaturan tersimpan. Perubahan yang belum disimpan dapat hilang; akun tidak dikeluarkan.</p>
        <button type="button" onClick={() => window.location.reload()} style={{ background: '#059669', color: '#ffffff', padding: '12px 18px', border: 0, borderRadius: 8, cursor: 'pointer', fontSize: 16 }}>Muat ulang halaman</button>
      </div>
    </main>;
  }
}
